export const chevronRightStyles = theme => ({
  color: theme.palette.secondary.main,
  gridColumn: 3,
  gridRow: 1,
  justifySelf: 'end',
  size: 24,
});

export const chipStylesStyles = theme => ({
  ...theme.typography.caption,
  alignItems: 'center',
  backgroundColor: theme.palette.secondary.light,
  borderRadius: 0.5,
  color: theme.palette.text.primary,
  display: 'flex',
  fontWeight: 400,
  height: 20,
  justifyContent: 'center',
  letterSpacing: 0.4,
  transition: [
    ['background', '300ms', 'cubic-bezier(0.4, 0, 0.2, 1)', '0ms'],
    ['box-shadow', '300ms', 'cubic-bezier(0.4, 0, 0.2, 1)', '0ms'],
  ],
  width: 25,
});

export const chipStylesSelectedStyles = theme => ({
  ...theme.typography.caption,
  alignItems: 'center',
  backgroundColor: theme.palette.primary.light,
  borderRadius: 0.5,
  color: theme.palette.text.primary,
  display: 'flex',
  fontWeight: 400,
  height: 20,
  justifyContent: 'center',
  letterSpacing: 0.4,
  width: 25,
});

export const inactiveCountStyles = theme => ({
  ...theme.typography.caption,
  alignItems: 'center',
  backgroundColor: theme.palette.surface.white,
  border: `1px solid ${theme.palette.graphic.light}`,
  borderRadius: 0.5,
  color: theme.palette.text.secondary,
  display: 'flex',
  fontWeight: 400,
  height: 20,
  justifyContent: 'center',
  letterSpacing: 0.4,
  marginRight: theme.spacing(1),
  transition: [
    ['background', '300ms', 'cubic-bezier(0.4, 0, 0.2, 1)', '0ms'],
    ['box-shadow', '300ms', 'cubic-bezier(0.4, 0, 0.2, 1)', '0ms'],
  ],
  width: 25,
});

export const inactiveCountSelectedStyles = theme => ({
  ...theme.typography.caption,
  alignItems: 'center',
  border: `1px solid ${theme.palette.graphic.light}`,
  borderRadius: 0.5,
  color: theme.palette.text.secondary,
  display: 'flex',
  fontWeight: 400,
  height: 20,
  justifyContent: 'center',
  letterSpacing: 0.4,
  marginRight: theme.spacing(1),
  width: 25,
});

export const labelStyles = theme => ({
  ...theme.typography.body2,
  gridColumn: '2 / span 2',
});

export const linkStyles = theme => ({
  '&:hover': {
    '& $chipStyles': {
      backgroundColor: theme.palette.primary.light,
    },
    '& $inactiveCount': {
      backgroundColor: theme.palette.secondary.light,
    },
    backgroundColor: theme.palette.secondary.light,
  },
  borderBottom: `1px solid ${theme.palette.surface.swimlane}`,
  borderRadius: 0.5,
  columnGap: theme.spacing(1),
  display: 'grid',
  gridGap: theme.spacing(1),
  gridTemplateColumns: `${theme.spacing(4)} 1fr ${theme.spacing(4)}`,
  padding: theme.spacing(3, 2),
  position: 'relative',
  rowGap: theme.spacing(1),
  textDecoration: 'none',
  width: '100%',
});

export const listStyles = {
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  msOverflowStyle: 'none',
  scrollbarWidth: 'none',
};

export const selectedListItemStyles = theme => ({
  backgroundColor: theme.palette.secondary.light,
  borderRadius: 0.5,
});

export const titleStyles = theme => ({
  color: theme.palette.primary.dark,
  fontFamily: 'Overpass',
  fontSize: 16,
  fontWeight: 400,
  gridColumn: '1 / 3',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  [theme.breakpoints.down('lg')]: {
    flex: 'none',
  },
});
